import type { AppConfig } from '../appConfig';

const configDev: AppConfig = {
  env: 'dev',
  url: {
    userWeb: `http://localhost:3040`,
    customerWeb: `http://localhost:3020`,
  },
  apiGateway: {
    region: 'ap-northeast-1',
    endpoint: `http://localhost:3010/dev`,
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: {
      staticContents: {
        name: `branq-${import.meta.env.VITE_STAGE}-static-contents`,
        endpoint: `https://d25t7fumcnp5h2.cloudfront.net`,
      },
      upload: {
        name: `branq-${import.meta.env.VITE_STAGE}-upload`,
      },
    },
  },
  ses: {
    from: {
      address: 'no-reply@branq.jp',
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_0HfkNJRbv',
    clientId: '428p3abmhc91bmkj439a1fd55c',
    identityPoolId: 'ap-northeast-1:0777d8e7-a4ba-41b2-84d4-fb6b35683e0b',
  },
};

export default configDev;
